// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"108d3ef5","418":"583f1ca1","668":"788284d2"}[chunkId] + ".js";
};